function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M46.28 32.72c-7.58 0-13.78 6.2-13.78 13.76s6.2 13.78 13.78 13.76 13.78-6.2 13.78-13.76-6.2-13.78-13.78-13.76z",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.88 38.7v6.98c0 0.4 0.4 1.02 1.02 1h4.98",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.32 42.7h-23.74c-1.8 0-3.2-1.38-3.2-3.2v-29.12c0-1.8 1.38-3.2 3.2-3.2h33.32c1.8 0 3.2 1.38 3.2 3.2v19.74",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1 20.34h-39.7",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.98 2.8v8.78",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.32 2.8v8.78",
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.38 27.32c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2 0-0.8 0.4-1.2 1.2-1.2 0.8 0 1.2 0.58 1.2 1.2z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.34 27.32c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2 0-0.8 0.4-1.2 1.2-1.2 1.02 0 1.2 0.58 1.2 1.2z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.38 35.7c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2s0.4-1.2 1.2-1.2 1.2 0.58 1.2 1.2z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.34 35.7c0 0.58-0.4 1.2-1.2 1.2-0.58 0-1.2-0.4-1.2-1.2s0.4-1.2 1.2-1.2c1.02 0 1.2 0.58 1.2 1.2z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.52 27.32c0 0.58-0.4 1.2-1.2 1.2s-1.2-0.58-1.2-1.2 0.4-1.2 1.2-1.2c0.8 0 1.2 0.58 1.2 1.2z",
  strokeMiterlimit: 10
}));

var SvgSchedule = function SvgSchedule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSchedule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule.92190548.svg";
export { ForwardRef as ReactComponent };